import React from "react";
import { useEffect } from "react";
import DatePicker from "react-date-picker";
import axios from "axios";
import "./AcceptedRequests.css";
import { Helmet } from "react-helmet";

import Navbarlogedin from "./Navbarlogedin";
import AcceptedRequest from "./cards/AcceptedRequest";

const changeLink = () => {
  const links = document.querySelectorAll(".nav-item a p");
  links.forEach((link) => {
    if (link.classList.contains("active")) {
      link.classList.remove("active");
    }
    if (link.innerHTML === 'Accepted Requests <div className="notify"></div>') {
      link.classList.add("active");
    }
  });
};

const AcceptedRequests = (userDetails) => {
  useEffect(() => {
    changeLink();
  }, []);
  const user = userDetails.user;
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    console.log(currentScrollPos);
    if (currentScrollPos >= 104) {
      document.querySelector(".interview-head").style.position = "sticky";
      document.querySelector(".interview-head").style.top = "0";
    } else {
      document.querySelector(".interview-head").style.position = "unset";
      document.querySelector(".interview-head").style.top = "0";
    }
    prevScrollpos = currentScrollPos;
  };
  const [count, setCount] = React.useState(0);
  const [cards, setCards] = React.useState();
  useEffect(() => {
    async function fetchData() {
      const req = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/get`);
      setCards(req.data);
      for (let i = 0; i < req.data.length; i++) {
        if (req.data[i].status === "accepted") {
          setCount(count + 1);
          console.log(count);
        }
      }
    }
    fetchData();
  }, []);
  const [date, setDate] = React.useState(null);
  return (
    <>
      <Helmet>
        <title>Interwiu | Accepted Request</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <div className="accepted-request interviews">
        <div className="interviews-container">
          <div className="flex justify-center items-center my-4" id="head">
            <h2 className="interview-head text-2xl font-medium">
              Accepted Requests {count ? count : 0}
            </h2>
          </div>
          <div className="interviews-cont">
            <div className="flex justify-between mx-8">
              <div>
                Showing the results for{" "}
                {date ? date.toDateString() : "all days"}
              </div>
              <div className="flex gap-2">
                <label htmlFor="date">Filter by Date: </label>
                <DatePicker
                  onChange={(newValue) => {
                    setDate(newValue);
                  }}
                  value={date}
                />
              </div>
            </div>
            <div className="interviews-list">
              <AcceptedRequest
                name="John Doe"
                desg="ML Engineer, YouTube, Google"
                price="399"
                profile="Data Science"
                slot="5:00PM - 5:30PM"
                id="#7a9fd8"
                status="accepted"
                payment={false}
                card_id="{result._id}"
                logo={require("../../images/amazon.png")}
              />
              <AcceptedRequest
                name="John Doe"
                desg="ML Engineer, YouTube, Google"
                price="399"
                profile="Data Science"
                slot="5:00PM - 5:30PM"
                id="#7a9fd8"
                status="accepted"
                payment={false}
                card_id="{result._id}"
                logo={require("../../images/amazon.png")}
              />
              {cards?.map((result) => (
                <AcceptedRequest
                  user={user}
                  name={result.toname}
                  desg={result.desg}
                  price={result.price}
                  profile={result.profile}
                  slot={result.slot}
                  status={result.status}
                  payment={result.payment}
                  card_id={result._id}
                  logo={require("../../images/amazon.png")}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcceptedRequests;
